<div class="travel-wrap">
    <div class="container">
        <div class="row justify-content-center mt-5">
            <div class="col-auto">
                <h1>Upload your JSON file</h1>
                <input class="mt-3" type="file" (change)="onFileChanged($event)" #fileInput>
            </div>
        </div>
        <div class="row justify-content-center mt-5">
            <div class="col-auto">
                <div class="d-inline" *ngIf="lastPlaceShow.type == 'activity'">Via {{lastPlaceShow.name}}</div>
                <div *ngIf="lastPlaceShow.type == 'place'">From {{lastPlaceShow.name}}</div>
                <div class="d-inline" *ngIf="currentPlaceShow.type == 'activity'">via {{currentPlaceShow.name}}</div>
                <div *ngIf="currentPlaceShow.type == 'place'">traveled to {{currentPlaceShow.name}}</div>
                <!-- <div *ngFor="let travel of travelArr">
                    <div class="d-inline" *ngIf="travel.type == 'activity'">{{travel.name}} traveled to:</div>
                    <div *ngIf="travel.type == 'place'">{{travel.name}}</div>
                    <br *ngIf="travel.type == 'place'">
                </div> -->
            </div>
        </div>
        <div class="row justify-content-center mt-5" *ngIf="travelArr.length > 0">
            <div class="col-auto">
                <button (click)="showPlaces()">next</button>
            </div>
        </div>
    </div>
</div>